import { Modal, Typography, Divider, Descriptions } from "antd";
import { useEffect, useState } from "react";
import { formatShiftTime } from "../util/helperFunction";
import CommonUtil from "../util/CommonUtils";
import { ReactComponent as CloseButton } from "../assets/images/close_btn.svg";
import { isAfter, isBefore, parse } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { setModalOpen } from "../feature/application/appSlice";
import { selectProvision } from "../feature/Dashboard/dashboardSelectors";
import { useTranslation } from "react-i18next";
const { Text } = Typography;

const labelStyle = { width: 100, textAlign: "left" };

const span = (
  <span
    style={{
      paddingRight: "15px",
      color: "#474A4E",
    }}
  >
    :
  </span>
);

const ShiftDetailsModel = ({
  isModalOpen,
  setIsModalOpen,
  employeeShiftData = {},
  showDetailsIfEmployeeUnderShift = true,
}) => {
  const {t} = useTranslation();
  const [shiftData, setShiftData] = useState(employeeShiftData);
  const dispatch = useDispatch();
  const { display_shift_details_date_and_time_formate: dateTimeFormat } = useSelector(selectProvision);

  useEffect(() => {
    if (!employeeShiftData?.endTime || !employeeShiftData?.shiftDate) {
      setShiftData({});
      return;
    }

    const dateFormat = "MM/dd/yyyy HH:mm";

    const shiftEndDateTime = parse(
      `${employeeShiftData.shiftDate} ${employeeShiftData.endTime}`,
      dateFormat,
      new Date(),
    );

    const shiftStartDateTime = parse(
      `${employeeShiftData.shiftDate} ${employeeShiftData.startTime}`,
      dateFormat,
      new Date(),
    );

    const currentTime = new Date();

    if (
      (isAfter(currentTime, shiftEndDateTime) || isBefore(currentTime, shiftStartDateTime)) &&
      showDetailsIfEmployeeUnderShift
    ) {
      setShiftData({});
    } else {
      setShiftData(employeeShiftData);
    }
  }, [employeeShiftData, showDetailsIfEmployeeUnderShift]);

  useEffect(() => {
    dispatch(setModalOpen(isModalOpen));
  }, [isModalOpen, dispatch]);

  const handleModelCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title={t("shiftDetailsModel.title")}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      width={500}
      centered
      maskClosable={false}
      closeIcon={null}
      style={{
        marginTop: "10px",
      }}
    >
      <CloseButton
        onClick={handleModelCancel}
        style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
      />
      <Divider
        style={{
          margin: "10px 0px",
        }}
      />

      <Descriptions column={1} size="small" colon={false}>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.shiftTime")}</Text>} labelStyle={labelStyle}>
          {span} {formatShiftTime(shiftData?.startTime, shiftData?.endTime, shiftData?.shiftDate, dateTimeFormat)}
        </Descriptions.Item>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.costCenter")}</Text>} labelStyle={labelStyle}>
          {span}
          {!CommonUtil.isEmptyString(shiftData?.costCenter) ? shiftData?.costCenter : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.location")}</Text>} labelStyle={labelStyle}>
          {span} {!CommonUtil.isEmptyString(shiftData.location) ? shiftData.location : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.timeType")}</Text>} labelStyle={labelStyle}>
          {span}
          {!CommonUtil.isEmptyString(shiftData?.timeType) ? shiftData?.timeType : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.position")}</Text>} labelStyle={labelStyle}>
          {span}
          {!CommonUtil.isEmptyString(shiftData?.positionId) ? shiftData?.positionId : "-"}
        </Descriptions.Item>
        <Descriptions.Item label={<Text strong>{t("shiftDetailsModel.labels.workTag")}</Text>} labelStyle={labelStyle}>
          {span}
          {!CommonUtil.isEmptyString(shiftData?.workTag) ? shiftData?.workTag : "-"}
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
};

export default ShiftDetailsModel;
